/**
 * Función que entrega el tamaño de icono según el estado del tema.
 *
 * @param {string} fontSize Corresponde al tamaño de fuente entregado por el tema.
 * @returns {string} Retorna el tamaño del icono.
 */
export const getIconSize = (fontSize: string): string => {
  switch (fontSize) {
    case "sm":
      return "3rem";
    case "md":
      return "3.2rem";
    case "lg":
      return "3.4rem";
    default:
      return "3.2rem";
  }
};

/**
 * Función que entrega el tamaño de fuente según el estado del tema.
 *
 * @param {string} fontSize Corresponde al tamaño de fuente entregado por el tema.
 * @returns {string} Retorna el tamaño de fuente.
 */
export const getFontSize = (fontSize: string, type: 'link' | 'title' | 'text' | 'subtitle' = 'text') => {
  switch (fontSize) {
    case "sm":
      if (type === 'link') return "0.875rem";
      if (type === 'text') return "1rem";
      if (type === "subtitle") return "1.25rem";
      if (type === "title") return "1.625rem";
      return "1rem";
    case "md":
      if (type === "link") return "1rem";
      if (type === "text") return "1.25rem";
      if (type === "subtitle") return "1.5rem";
      if (type === "title") return "2rem";
      return "1.25rem";
    case "lg":
      if (type === "link") return "1.25rem";
      if (type === "text") return "1.5rem";
      if (type === "subtitle") return "2rem";
      if (type === "title") return "2.5rem";
      return "1.5rem";
    default:
      return "1.25rem";
  }
};
